import axios from 'axios'

import Client from './Clients/AxiosClient'
import { parseFilters } from './utils/ParseFilters'
const resource = 'sales_tax_requests'

export default {
  get (filters) {
    return Client.get(`${resource}?${parseFilters(filters)}`)
      .then(response => response.data)
  },
  getSalesTaxRequest (id, filters) {
    return Client.get(`${resource}/${id}?${parseFilters(filters)}`)
      .then(response => response.data)
  },
  create (payload) {
    return Client.post(`${resource}`, payload)
      .then(response => response.data)
  },
  update (payload, id) {
    return Client.put(`${resource}/${id}`, payload)
      .then(response => response.data)
  },
  delete (id) {
    return Client.delete(`${resource}/${id}`)
      .then(response => response.data)
  },
  getAvailableSalesTax (filters) {
    const filtersWithoutYear = Object.assign({}, filters)
    delete filtersWithoutYear['include_year']
    return axios.all([
      Client.post(`${resource}/overview/?${parseFilters(filters)}`),
      Client.post(`${resource}/requested/?${parseFilters(filters)}`),
      Client.post(`${resource}/overview/?${parseFilters(filtersWithoutYear)}`)
    ])
  }
}
